<template>
  <header class="header">
    <router-link to="/" class="logo text-decoration-none">
      <font-awesome-icon class="lightbulb" icon="lightbulb" />
      furni
    </router-link>

    <div class="navbar">
      <router-link :to="{ name: 'Home' }" class="home text-decoration-none"
        >home</router-link
      >
      <router-link :to="{ name: 'Shop' }" class="shop text-decoration-none"
        >shop</router-link
      >
      <router-link :to="{ name: 'About' }" class="about text-decoration-none"
        >about</router-link
      >
      <router-link :to="{ name: 'Team' }" class="team text-decoration-none"
        >team</router-link
      >
      <router-link :to="{ name: 'Blog' }" class="blog text-decoration-none"
        >blog</router-link
      >
      <router-link
        :to="{ name: 'Contact' }"
        class="contact text-decoration-none"
        >contact</router-link
      >
    </div>

    <form v-if="isShowSearch" action="" class="search-form">
      <input
        type="search"
        placeholder="search here..."
        class="search-box"
        id="search-box"
      />
      <label for="search-box"><font-awesome-icon icon="search" /></label>
    </form>

    <div class="icons">
      <div id="menu-btn" class="bars">
        <font-awesome-icon @click="toggle" icon="bars" />
      </div>
      <div id="search-btn" class="search">
        <font-awesome-icon @click="toggleSearch" icon="search" />
      </div>
      <div id="cart-btn" class="shopping-cart">
        <font-awesome-icon @click="toggleCart" icon="shopping-cart" />
      </div>
      <div id="login-btn" class="user">
        <font-awesome-icon @click="toggleLogin" icon="user" />
      </div>
    </div>

    <div v-if="isShow" class="menu">
      <div class="closer">
        <font-awesome-icon @click="toggle" icon="times" />
      </div>
      <router-link :to="{ name: 'Home' }" class="home text-decoration-none"
        >home</router-link
      >
      <router-link :to="{ name: 'Shop' }" class="shop text-decoration-none"
        >shop</router-link
      >
      <router-link :to="{ name: 'About' }" class="about text-decoration-none"
        >about</router-link
      >
      <router-link :to="{ name: 'Team' }" class="team text-decoration-none"
        >team</router-link
      >
      <router-link :to="{ name: 'Blog' }" class="blog text-decoration-none"
        >blog</router-link
      >
      <router-link
        :to="{ name: 'Contact' }"
        class="contact text-decoration-none"
        >contact</router-link
      >
    </div>
    <template v-else> </template>

    <div v-if="isShowCart" class="cart">
      <div class="closer">
        <font-awesome-icon @click="toggleCart" icon="times" />
      </div>
      <div v-for="cart in carts" :key="cart.id" class="box">
        <font-awesome-icon icon="times" class="times" />
        <img :src="cart.image" alt="" />
        <div class="content">
          <h3>{{ cart.name }}</h3>
          <span class="quantity"> {{ cart.quantity }} </span>
          <span class="multiply"> x </span>
          <span class="price"> {{ cart.price }} </span>
        </div>
      </div>

      <h3 class="total">total : <span>$560.00</span></h3>
      <router-link to="" class="btn text-decoration-none"
        >checkout cart</router-link
      >
    </div>

    <div v-if="isShowLogin" class="login-form">
      <div class="closer">
        <font-awesome-icon @click="toggleLogin" icon="times" />
      </div>
      <form action="">
        <h3>login-form</h3>
        <input type="email" placeholder="enter your email" class="box" />
        <input type="password" placeholder="enter your password" class="box" />
        <div class="remember">
          <input type="checkbox" name="" id="remember-me" />
          <label for="remember-me">remember me</label>
        </div>
        <input type="submit" value="login now" class="btn" />
        <p>
          forget password?
          <router-link to="" class="text-underline-hover"
            >click here</router-link
          >
        </p>
        <p>
          don't have an account?
          <router-link to="" class="text-underline-hover"
            >create now</router-link
          >
        </p>
      </form>
    </div>
  </header>
</template>

<script>
const dummyData = {
  carts: [
    {
      id: "1",
      name: "morden furniture",
      image: require("@/images/cart-img-1.jpg"),
      quantity: "1",
      price: "$140.00",
    },
    {
      id: "2",
      name: "morden furniture",
      image: require("@/images/cart-img-2.jpg"),
      quantity: "1",
      price: "$140.00",
    },
    {
      id: "3",
      name: "morden furniture",
      image: require("@/images/cart-img-3.jpg"),
      quantity: "1",
      price: "$140.00",
    },
    {
      id: "4",
      name: "morden furniture",
      image: require("@/images/cart-img-4.jpg"),
      quantity: "1",
      price: "$140.00",
    },
  ],
};

export default {
  data() {
    return {
      carts: [],
      isShow: false,
      isShowCart: false,
      isShowLogin: false,
      isShowSearch: false,
    };
  },
  created() {
    this.fetchCarts();
  },
  methods: {
    fetchCarts() {
      this.carts = dummyData.carts;
    },
    toggle() {
      this.isShow = !this.isShow;
    },
    toggleCart() {
      this.isShowCart = !this.isShowCart;
    },
    toggleLogin() {
      this.isShowLogin = !this.isShowLogin;
    },
    toggleSearch() {
      this.isShowSearch = !this.isShowSearch;
    },
  },
};
</script>